import React from 'react';

import { MultiSelect, normalizeMultiSelectValue } from '@gogame/components';

import Filter from '../Filter';
import getTitle from '../getTitle';

const FilterMultiSelect = ({
  title,
  name,
  source,
  sourceLimit,
  depends,
  withClear,
  withFavoriteActions,
  placeholder,
  disabled,
  disableEmpty,
  isOptionDisabled,
  withAll = true,
  withSelectAll = true,
  favorits,
  favoritsLabel,
  multiFields,
  actions,
  lazy,
  suffix,
  compareActions,
  required,
  renderValue,
  renderOption,
  dropdownWidth,
  serverSideSearch = false,
  dropdownInputPlaceholder,
  ['data-cy']: dataCy,
  maxOptionsSelected,
}) => {
  let normalizedIsOptionDisabled = isOptionDisabled;

  if (maxOptionsSelected) {
    normalizedIsOptionDisabled = (option, selectedOptions) => {
      const selectedOptionsIds = selectedOptions.map(({ id }) => id);

      if (selectedOptionsIds.length) {
        return (
          selectedOptionsIds.length === maxOptionsSelected &&
          !selectedOptionsIds.includes(option.id)
        );
      }
      return false;
    };
  }
  return (
    <Filter
      title={title}
      required={required}
      name={name}
      source={source}
      depends={depends}
      withClear={withClear}
      withFavoriteActions={withFavoriteActions}
      normalizeValue={normalizeMultiSelectValue}
      multiFields={multiFields}
      actions={actions}
      compareActions={compareActions}
      lazy={lazy}
      suffix={suffix}
      disabled={disabled}
      disableEmpty={disableEmpty}
      serverSideSearch={serverSideSearch}
      renderComponent={({
        label,
        value,
        options,
        loading,
        fetching,
        onChange,
        onFocus,
        actions,
        error,
        onSearch,
        onClose,
        searchOptions,
        minOptionCountForSearch,
        postFiltering,
        suffix,
        disabled,
      }) => (
        <MultiSelect
          data-cy={dataCy || name}
          label={label}
          value={value}
          options={options}
          searchOptions={searchOptions}
          sourceLimit={sourceLimit}
          loading={loading}
          fetching={fetching}
          onChange={onChange}
          onFocus={onFocus}
          actions={actions}
          suffix={suffix}
          placeholder={placeholder}
          displayPlaceholder={true}
          disabled={disabled}
          isOptionDisabled={normalizedIsOptionDisabled}
          withSelectAll={withSelectAll}
          withAll={withAll}
          favorits={favorits}
          favoritsLabel={favoritsLabel}
          renderValue={renderValue}
          renderOption={renderOption}
          dropdownWidth={dropdownWidth}
          error={error}
          padding={0}
          onSearch={onSearch}
          onClose={onClose}
          minOptionCountForSearch={minOptionCountForSearch}
          postFiltering={postFiltering}
          dropdownInputPlaceholder={dropdownInputPlaceholder}
        />
      )}
    />
  );
};

export default FilterMultiSelect;
